import { render, staticRenderFns } from "./trainingHistory.vue?vue&type=template&id=4905b3da&scoped=true"
import script from "./trainingHistory.vue?vue&type=script&lang=js"
export * from "./trainingHistory.vue?vue&type=script&lang=js"
import style0 from "./trainingHistory.vue?vue&type=style&index=0&id=4905b3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4905b3da",
  null
  
)

export default component.exports